var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "17px",
    viewBox: "0 0 23 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 21,
    height: 15,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A17A7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030E88",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8,10.3924892 L8,16 L13,16 L13,10.3924892 L21.9618519,16.4373347 L23.0802377,14.7792595 L15.9946941,10 L21,10 L21,5 L15.9946941,5 L23.0802377,0.220740472 L21.9618519,-1.43733467 L13,4.60751076 L13,-1 L8,-1 L8,4.60751076 L-0.961851899,-1.43733467 L-2.08023771,0.220740472 L5.00530593,5 L3.90798505e-14,5 L3.90798505e-14,10 L5.00530593,10 L-2.08023771,14.7792595 L-0.961851899,16.4373347 L8,10.3924892 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.25,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7273E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF152B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0,
    y: 0,
    width: 21,
    height: 15,
    rx: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1-Copy-3",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-3)",
    x: 0,
    y: 0,
    width: 21,
    height: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.0009766,4.74914551 L23.5,-1.5",
    id: "Line",
    stroke: "#DB1F35",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    mask: "url(#mask-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0095825,16.0127563 L23.5249634,10.2731323",
    id: "Line-Copy-2",
    stroke: "#DB1F35",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    mask: "url(#mask-3)",
    transform: "translate(19.267273, 13.142944) scale(1, -1) translate(-19.267273, -13.142944) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00415039,4.73284912 L-2.87811279,-1.25323486",
    id: "Line-Copy",
    stroke: "#DB1F35",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    mask: "url(#mask-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9675293,16.7328491 L-2.87811279,10.2036743",
    id: "Line-Copy-3",
    stroke: "#DB1F35",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    mask: "url(#mask-3)",
    transform: "translate(2.044708, 13.468262) scale(1, -1) translate(-2.044708, -13.468262) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2-Copy-3",
    fill: "url(#linearGradient-8)",
    mask: "url(#mask-3)",
    points: "0 9 9 9 9 15 12 15 12 9 21 9 21 6 12 6 12 0 9 0 9 6 0 6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Depth"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.f0befaab4524017ec87556c7e5985658.svg";
export { ForwardRef as ReactComponent };